import React from "react";
import { useState } from "react";

import imageOne from "../../../assets/1a Lisa.png";
import imageTwo from "../../../assets/Write sentences.png";

function LessonThree() {
  const [q1, setQ1] = useState("");
  const [q2, setQ2] = useState("");
  const [q3, setQ3] = useState("");
  const [q4, setQ4] = useState("");
  const [q5, setQ5] = useState("");
  const [q6, setQ6] = useState("");
  const [q7, setQ7] = useState("");
  const [q8, setQ8] = useState("");
  const [q9, setQ9] = useState("");
  const [q10, setQ10] = useState("");
  const [q11, setQ11] = useState("");
  const [q12, setQ12] = useState("");
  const [q13, setQ13] = useState("");
  const [q14, setQ14] = useState("");
  const [q15, setQ15] = useState("");
  const [q16, setQ16] = useState("");
  const [q17, setQ17] = useState("");
  const [q18, setQ18] = useState("");
  const [q19, setQ19] = useState("");
  const [q20, setQ20] = useState("");
  const [q21, setQ21] = useState("");
  const [q22, setQ22] = useState("");
  const [q23, setQ23] = useState("");
  const [q24, setQ24] = useState("");
  const [q25, setQ25] = useState("");
  const [q26, setQ26] = useState("");
  const [q27, setQ27] = useState("");
  const [q28, setQ28] = useState("");
  const [q29, setQ29] = useState("");
  const [q30, setQ30] = useState("");
  const [q31, setQ31] = useState("");
  const [q32, setQ32] = useState("");
  const [q33, setQ33] = useState("");
  const [q34, setQ34] = useState("");
  const [q35, setQ35] = useState("");
  const [q36, setQ36] = useState("");
  const [q37, setQ37] = useState("");
  const [q38, setQ38] = useState("");
  const [q39, setQ39] = useState("");
  const [q40, setQ40] = useState("");
  return (
    <>
      <div className="">
        <div className="task-one mb-3">
          <h4>
            <span>2.1</span> Find the right answers for the questions.
          </h4>
          <p className="table row">
            <ol className="q-table border col-xsm-12 col-sm-12 col-md-4 col-lg-4 col-xlg-4 ">
              <li>Where's the camera?</li>
              <li>Is your car blue?</li>
              <li>Is Kate from London?</li>
              <li>Am I late?</li>
              <li>Where's Amy from?</li>
              <li>What colour is your bag?</li>
              <li>Are you hungry?</li>
              <li>How is George?</li>
              <li>Who's that woman?</li>
            </ol>
            <ul className="border col-xsm-12 col-sm-12 col-md-4 col-lg-4 col-xlg-4 ">
              <li>A - London.</li>
              <li>B - No, I'm not.</li>
              <li>C - Yes, you are.</li>
              <li>D - My sister.</li>
              <li>E - Black.</li>
              <li>F - No, it's black.</li>
              <li>G - In your bag.</li>
              <li>H - No, she's American</li>
              <li>I - Very well.</li>
            </ul>
            <ol className="border col-xsm-12 col-sm-12 col-md-4 col-lg-4 col-xlg-4 ">
              <li>
                <input
                  className="border"
                  value="G"
                  disabled
                  style={{ background: "#198754", color: "white" }}
                />
              </li>
              <li>
                <input
                  className="border"
                  onChange={(e) => setQ1(e.target.value)}
                  style={{
                    background: q1.trim() === "F" ? "#198754" : "white",
                    color: q1.trim() === "F" ? "white" : "black",
                  }}
                />
              </li>
              <li>
                <input
                  className="border"
                  onChange={(e) => setQ2(e.target.value)}
                  style={{
                    background: q2.trim() === "H" ? "#198754" : "white",
                    color: q2.trim() === "H" ? "white" : "black",
                  }}
                />
              </li>
              <li>
                <input
                  className="border"
                  onChange={(e) => setQ3(e.target.value)}
                  style={{
                    background: q3.trim() === "C" ? "#198754" : "white",
                    color: q3.trim() === "C" ? "white" : "black",
                  }}
                />
              </li>
              <li>
                <input
                  className="border"
                  onChange={(e) => setQ4(e.target.value)}
                  style={{
                    background: q4.trim() === "A" ? "#198754" : "white",
                    color: q4.trim() === "A" ? "white" : "black",
                  }}
                />
              </li>
              <li>
                <input
                  className="border"
                  onChange={(e) => setQ5(e.target.value)}
                  style={{
                    background: q5.trim() === "E" ? "#198754" : "white",
                    color: q5.trim() === "E" ? "white" : "black",
                  }}
                />
              </li>
              <li>
                <input
                  className="border"
                  onChange={(e) => setQ6(e.target.value)}
                  style={{
                    background: q6.trim() === "B" ? "#198754" : "white",
                    color: q6.trim() === "B" ? "white" : "black",
                  }}
                />
              </li>
              <li>
                <input
                  className="border"
                  onChange={(e) => setQ7(e.target.value)}
                  style={{
                    background: q7.trim() === "I" ? "#198754" : "white",
                    color: q7.trim() === "I" ? "white" : "black",
                  }}
                />
              </li>
              <li>
                <input
                  className="border"
                  onChange={(e) => setQ8(e.target.value)}
                  style={{
                    background: q8.trim() === "D" ? "#198754" : "white",
                    color: q8.trim() === "D" ? "white" : "black",
                  }}
                />
              </li>
            </ol>
          </p>
        </div>

        <hr />

        <div className="task-two mb-3">
          <h4>
            <span>2.2</span> Make questions with these words.
          </h4>
          <p className="table row">
            <ol className="border">
              <li>
                (is / at home / your mother)
                <input
                  className="border"
                  value="Is your mother at home?"
                  disabled
                  onChange={(e) => setQ9(e.target.value)}
                  style={{
                    background: "#198754",
                    color: "white",
                  }}
                />
                ?
              </li>
              <li>
                (your parents / are / well)
                <input
                  className="border"
                  onChange={(e) => setQ10(e.target.value)}
                  style={{
                    background:
                      q10.trim() === "Are your parents well"
                        ? "#198754"
                        : "white",
                    color:
                      q10.trim() === "Are your parents well"
                        ? "white"
                        : "black",
                  }}
                />
                ?
              </li>
              <li>
                (interesting / is / your job)
                <input
                  className="border"
                  onChange={(e) => setQ11(e.target.value)}
                  style={{
                    background:
                      q11.trim() === "Is your job interesting"
                        ? "#198754"
                        : "white",
                    color:
                      q11.trim() === "Is your job interesting"
                        ? "white"
                        : "black",
                  }}
                />
                ?
              </li>
              <li>
                (the shops / are / opern today)
                <input
                  className="border"
                  onChange={(e) => setQ12(e.target.value)}
                  style={{
                    background:
                      q12.trim() === "Are the shops open today"
                        ? "#198754"
                        : "white",
                    color:
                      q12.trim() === "Are the shops open today"
                        ? "white"
                        : "black",
                  }}
                />
                ?
              </li>
              <li>
                (from / where / you / are)
                <input
                  className="border"
                  onChange={(e) => setQ13(e.target.value)}
                  style={{
                    background:
                      q13.trim() === "Where are you from" ? "#198754" : "white",
                    color:
                      q13.trim() === "Where are you from" ? "white" : "black",
                  }}
                />
                ?
              </li>
              <li>
                (interested in sports / you / are)
                <input
                  className="border"
                  onChange={(e) => setQ14(e.target.value)}
                  style={{
                    background:
                      q14.trim() === "Are you interested in sports"
                        ? "#198754"
                        : "white",
                    color:
                      q14.trim() === "Are you interested in sports"
                        ? "white"
                        : "black",
                  }}
                />{" "}
                ?
              </li>
              <li>
                (is / near here / the station)
                <input
                  className="border"
                  onChange={(e) => setQ15(e.target.value)}
                  style={{
                    background:
                      q15.trim() === "Is the station near here"
                        ? "#198754"
                        : "white",
                    color:
                      q15.trim() === "Is the station near here"
                        ? "white"
                        : "black",
                  }}
                />{" "}
                ?
              </li>
              <li>
                (at school / are / your children)
                <input
                  className="border"
                  onChange={(e) => setQ16(e.target.value)}
                  style={{
                    background:
                      q16.trim() === "Are your children at school"
                        ? "#198754"
                        : "white",
                    color:
                      q16.trim() === "Are your children at school"
                        ? "white"
                        : "black",
                  }}
                />{" "}
                ?
              </li>
              <li>
                (you / are / late / why)
                <input
                  className="border"
                  onChange={(e) => setQ17(e.target.value)}
                  style={{
                    background:
                      q17.trim() === "Why are you late" ? "#198754" : "white",
                    color:
                      q17.trim() === "Why are you late" ? "white" : "black",
                  }}
                />{" "}
                ?
              </li>
            </ol>
          </p>
        </div>

        <hr />

        <div className="task-three mb-3 row ">
          <h4>
            <span>2.3</span> Write the questions.
          </h4>
          <p className="table row">
            <ol className="border col-xsm-12 col-sm-12 col-md-7 col-lg-7 col-xlg-7">
              <li>
                (name?)
                <input
                  className="border"
                  value="What's your name?"
                  disabled
                  onChange={(e) => setQ18(e.target.value)}
                  style={{
                    background: "#198754",
                    color: "white",
                  }}
                />
              </li>
              <li>
                (American?)
                <input
                  className="border"
                  onChange={(e) => setQ19(e.target.value)}
                  style={{
                    background:
                      q19.trim() === "Are you American?" ? "#198754" : "white",
                    color:
                      q19.trim() === "Are you American?" ? "white" : "black",
                  }}
                />
              </li>
              <li>
                (how old?)
                <input
                  className="border"
                  onChange={(e) => setQ20(e.target.value)}
                  style={{
                    background:
                      q20.trim() === "How old are you?" ? "#198754" : "white",
                    color:
                      q20.trim() === "How old are you?" ? "white" : "black",
                  }}
                />
              </li>
              <li>
                (a teacher?)
                <input
                  className="border"
                  onChange={(e) => setQ21(e.target.value)}
                  style={{
                    background:
                      q21.trim() === "Are you a teacher?" ? "#198754" : "white",
                    color:
                      q21.trim() === "Are you a teacher?" ? "white" : "black",
                  }}
                />
              </li>
              <li>
                (married?)
                <input
                  className="border"
                  onChange={(e) => setQ22(e.target.value)}
                  style={{
                    background:
                      q22.trim() === "Are you married?" ? "#198754" : "white",
                    color:
                      q22.trim() === "Are you married?" ? "white" : "black",
                  }}
                />
              </li>
              <li>
                (wife a lawyer?)
                <input
                  className="border"
                  onChange={(e) => setQ23(e.target.value)}
                  style={{
                    background:
                      q23.trim() === "Is your wife a lawyer?"
                        ? "#198754"
                        : "white",
                    color:
                      q23.trim() === "Is your wife a lawyer?"
                        ? "white"
                        : "black",
                  }}
                />
              </li>
              <li>
                (from?)
                <input
                  className="border"
                  onChange={(e) => setQ24(e.target.value)}
                  style={{
                    background:
                      q24.trim() === "Where is she from?" ? "#198754" : "white",
                    color:
                      q24.trim() === "Where is she from?" ? "white" : "black",
                  }}
                />
              </li>
              <li>
                (her name?)
                <input
                  className="border"
                  onChange={(e) => setQ25(e.target.value)}
                  style={{
                    background:
                      q25.trim() === "What's her name?"
                        ? "#198754"
                        : q25.trim() === "What is her name?"
                        ? "#198754"
                        : "white",
                    color:
                      q25.trim() === "What's her name?"
                        ? "white"
                        : q25.trim() === "What is her name?"
                        ? "white"
                        : "black",
                  }}
                />
              </li>
              <li>
                (how old?)
                <input
                  className="border"
                  onChange={(e) => setQ26(e.target.value)}
                  style={{
                    background:
                      q26.trim() === "How old is she?" ? "#198754" : "white",
                    color: q26.trim() === "How old is she?" ? "white" : "black",
                  }}
                />
              </li>
            </ol>
            <ul className="border col-xsm-12 col-sm-12 col-md-3 col-lg-3 col-xlg-3">
              <li>Paul.</li>
              <li>No, I'm Australian.</li>
              <li>I'm 30. ?</li>
              <li>No, I'm a lawyer.</li>
              <li>Yes, I am.</li>
              <li>(wife a lawyer?) No, she's a designer.</li>
              <li>She's Italian.</li>
              <li>Anna.</li>
              <li>She's 27.</li>
            </ul>
          </p>
        </div>

        <hr />

        <div className="task-four mb-3">
          <h4>
            <span>2.4</span> Write short answers{" "}
            <span>
              (<strong>Yes, I am. / No, he isn't.</strong> etc.)
            </span>
            .
          </h4>
          <p className="table row">
            <ol className="border">
              <li>
                Are you married?
                <input
                  className="border"
                  value="No, I'm not."
                  disabled
                  style={{ background: "#198754", color: "white" }}
                />
              </li>
              <li>
                Are you thirsty?
                <input
                  className="border"
                  onChange={(e) => setQ27(e.target.value)}
                  style={{
                    background:
                      q27.trim() === "Yes, I am."
                        ? "#198754"
                        : q27.trim() === "No, I'm not."
                        ? "#198754"
                        : "white",
                    color:
                      q27.trim() === "Yes, I am."
                        ? "white"
                        : q27.trim() === "No, I'm not."
                        ? "#198754"
                        : "black",
                  }}
                />
              </li>
              <li>
                Is it cold today?
                <input
                  className="border"
                  onChange={(e) => setQ28(e.target.value)}
                  style={{
                    background:
                      q28.trim() === "Yes, it is."
                        ? "#198754"
                        : q28.trim() === "No, it's not."
                        ? "#198754"
                        : q28.trim() === "No, it isn't."
                        ? "#198754"
                        : "white",
                    color:
                      q28.trim() === "Yes, it is."
                        ? "white"
                        : q28.trim() === "No, it's not."
                        ? "white"
                        : q28.trim() === "No, it isn't."
                        ? "white"
                        : "black",
                  }}
                />
              </li>
              <li>
                Are your hands cold?
                <input
                  className="border"
                  onChange={(e) => setQ29(e.target.value)}
                  style={{
                    background:
                      q29.trim() === "Yes, they are."
                        ? "#198754"
                        : q29.trim() === "No, they're not."
                        ? "#198754"
                        : q29.trim() === "No, they aren't."
                        ? "#198754"
                        : "white",
                    color:
                      q29.trim() === "Yes, they are."
                        ? "white"
                        : q29.trim() === "No, they're not."
                        ? "white"
                        : q29.trim() === "No, they aren't."
                        ? "white"
                        : "black",
                  }}
                />
              </li>
              <li>
                Is it dark now?
                <input
                  className="border"
                  onChange={(e) => setQ30(e.target.value)}
                  style={{
                    background:
                      q30.trim() === "Yes, it is."
                        ? "#198754"
                        : q30.trim() === "No, it's not."
                        ? "#198754"
                        : q30.trim() === "No, it isn't."
                        ? "#198754"
                        : "white",
                    color:
                      q30.trim() === "Yes, it is."
                        ? "white"
                        : q30.trim() === "No, it's not."
                        ? "white"
                        : q30.trim() === "No, it isn't."
                        ? "white"
                        : "black",
                  }}
                />
              </li>
              <li>
                Are you a teacher?
                <input
                  className="border"
                  onChange={(e) => setQ31(e.target.value)}
                  style={{
                    background:
                      q31.trim() === "Yes, I am."
                        ? "#198754"
                        : q31.trim() === "No, I'm not."
                        ? "#198754"
                        : "white",
                    color:
                      q31.trim() === "Yes, I am."
                        ? "white"
                        : q31.trim() === "No, I'm not."
                        ? "white"
                        : "black",
                  }}
                />
              </li>
            </ol>
          </p>
        </div>

        <hr />

        <div className="task-five mb-3">
          <h4>
            <span>2.5</span> Complete the questions. Use
            <span>
              (<strong>What... / Who... / Where / How... .</strong> etc.)
            </span>
            .
          </h4>
          <p className="table row">
            <ol className="border col-xsm-12 col-sm-12 col-md-7 col-lg-7 col-xlg-7">
              <li>
                <input
                  className="border"
                  value="How are"
                  disabled
                  style={{ background: "#198754", color: "white" }}
                />
                your parents?
              </li>
              <li>
                <input
                  className="border"
                  onChange={(e) => setQ32(e.target.value)}
                  style={{
                    background:
                      q32.trim() === "Where is"
                        ? "#198754"
                        : q32.trim() === "Where's"
                        ? "#198754"
                        : "white",
                    color:
                      q32.trim() === "Where is"
                        ? "white"
                        : q32.trim() === "Where's"
                        ? "#198754"
                        : "black",
                  }}
                />{" "}
                the bus stop?
              </li>
              <li>
                <input
                  className="border"
                  onChange={(e) => setQ33(e.target.value)}
                  style={{
                    background:
                      q33.trim() === "How old are" ? "#198754" : "white",
                    color: q33.trim() === "How old are" ? "white" : "black",
                  }}
                />{" "}
                your children?
              </li>
              <li>
                <input
                  className="border"
                  onChange={(e) => setQ34(e.target.value)}
                  style={{
                    background:
                      q34.trim() === "How much are" ? "#198754" : "white",
                    color: q34.trim() === "How much are" ? "white" : "black",
                  }}
                />{" "}
                these oranges?
              </li>
              <li>
                <input
                  className="border"
                  onChange={(e) => setQ35(e.target.value)}
                  style={{
                    background: q35.trim() === "What is" ? "#198754" : "white",
                    color: q35.trim() === "What is" ? "white" : "black",
                  }}
                />{" "}
                your favourite sport?
              </li>
              <li>
                <input
                  className="border"
                  onChange={(e) => setQ36(e.target.value)}
                  style={{
                    background:
                      q36.trim() === "Who is"
                        ? "#198754"
                        : q36.trim() === "Who's"
                        ? "#198754"
                        : "white",
                    color:
                      q36.trim() === "Who is"
                        ? "white"
                        : q36.trim() === "Who's"
                        ? "white"
                        : "black",
                  }}
                />
                the man in the photo?
              </li>
              <li>
                <input
                  className="border"
                  onChange={(e) => setQ37(e.target.value)}
                  style={{
                    background:
                      q37.trim() === "What color are"
                        ? "#198754"
                        : q37.trim() === "What colour are"
                        ? "#198754"
                        : "white",
                    color:
                      q37.trim() === "What color are"
                        ? "white"
                        : q37.trim() === "What colour are"
                        ? "white"
                        : "black",
                  }}
                />
                your new shoes?
              </li>
            </ol>
            <ul className="border col-xsm-12 col-sm-12 col-md-3 col-lg-3 col-xlg-3">
              <li>They're very well.</li>
              <li>At the end of the street.</li>
              <li>Five, six and ten.</li>
              <li>$1.50 a kilo.</li>
              <li>Skiing.</li>
              <li>That's my father.</li>
              <li>Black.</li>
            </ul>
          </p>
        </div>
      </div>
    </>
  );
}

export default LessonThree;
